module.exports = __webpack_public_path__ + "static/gausdal-0a1988d535a6e1f22c405c08cb0a8e0e.png";